import { authConfig } from "../apiConfig";

// NEW REUSABLE FUNCTION FOR DASHBOARD WITH PARAMS
export const fetchDashboardDataByRole = async (endpoint, data = {}) => {
    try {
        const response = await authConfig.post(endpoint, data);
        return response.data;
    } catch (error) {
        console.error(`Error fetching dashboard data for ${endpoint}:`, error);
        throw error;
    }
};
